import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";

export default function NewsSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div>
      <a href={attributes.linkUrl ?? "/"}>
        <img src={attributes.imageUrl} alt={attributes.title} />
        <p>{attributes.content}</p>
        <h3>{attributes.title}</h3>
      </a>
    </div>
  );
}
